module.exports = __webpack_public_path__ + "img/acier_pique.7cf32784.jpeg";